import { Injectable, inject } from '@angular/core';
import { type Params } from '@angular/router';
import { type HttpErrorResponse } from '@angular/common/http';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { catchError, filter, map, switchMap, withLatestFrom, mergeMap } from 'rxjs/operators';

import { isUuid } from '@common/helpers';

import { DomainsHttpService } from '@web/store/website/domains/domains.http.service';

import { RouterFacade } from '@web/store/router/router.facade';

import AppActions from '@web/store/app/app.actions';
import DomainsActions from './domains.actions';

@Injectable()
export class DomainsEffects {
    private readonly actions$ = inject(Actions);
    private readonly routerFacade = inject(RouterFacade);
    private readonly domainsHttpService = inject(DomainsHttpService);

    public readonly loadDomainsRequest$ = createEffect(() =>
        this.actions$.pipe(
            ofType(AppActions.initAppSuccess, DomainsActions.loadDomainsRequest),
            withLatestFrom(this.routerFacade.routerParams$, (_, routerParams: Params) => ({
                routerParams,
            })),
            filter(({ routerParams }) => routerParams.siteId && !isUuid(routerParams.siteId)),
            mergeMap(({ routerParams }) => {
                return this.domainsHttpService.getSiteDomains(routerParams.siteId);
            }),
            map((domains) => {
                return DomainsActions.loadDomainsSuccess({ domains });
            })
        )
    );
}
